var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import { PageService } from "~/utils/page.service";
import ManualDistrubute from "~/components/case-import/manual-distrubute.vue";
import { namespace, State } from "vuex-class";
import { CaseInfoService } from "../../services/domain-service/case-info.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var CollectionExecutionModule = namespace("collection-execution");
var RecoveredCase = /** @class */ (function (_super) {
    __extends(RecoveredCase, _super);
    function RecoveredCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.importModel = {
            principalId: "",
            batchNumber: "",
            mobileNo: "",
            personalName: "",
            amountRange: { min: "", max: "" },
            caseNumber: '',
            principalName: '',
            partnerName: '',
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            idCard: '',
            loanDate: [],
            partDistributeDate: [],
            returnDate: [],
            dataFromSource: '',
            recoveryType: '',
            overdueDays: {
                max: "",
                min: ""
            },
            compensationMoney: {
                max: "",
                min: ""
            },
            debtCollector: ""
        };
        _this.dialog = {
            manual: false
        };
        // 表单验证规则
        _this.recoveredRule = {
            mobileNo: [
                {
                    validator: _this.$validator.phoneNumber,
                    trigger: "blur"
                }
            ]
        };
        _this.importDataSet = [];
        _this.selectionList = [];
        _this.caseDetail = {};
        return _this;
    }
    /**
     * 获取回收案件
     */
    RecoveredCase.prototype.refreshData = function () {
        var _this = this;
        this.CaseInfoService.getAllRecoveredCaseInfos(this.importModel, this.pageService).subscribe(function (data) {
            _this.importDataSet = data;
            _this.selectionList = [];
        });
    };
    RecoveredCase.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 手动分案
     */
    RecoveredCase.prototype.manualDistruibute = function () {
        // if (this.selectionList.length === 0) {
        // this.$message("请选择要分配的案件");
        this.dialog.manual = true;
        // } else {
        //     this.dialog.manual = true;
        // }
    };
    /**
     * 重置numberRange
     */
    RecoveredCase.prototype.follFeedback = function () {
        this.importModel.amountRange = { min: "", max: "" };
        this.importModel.dayRange = { min: "", max: "" };
        this.importModel.rateRange = { min: "", max: "" };
        this.importModel.caseMoney = { min: '', max: '' };
        this.importModel.compensationMoney = { min: "", max: "" };
        this.importModel.overdueDays = { min: "", max: "" };
    };
    /**
     * 进入查看执行页
     */
    RecoveredCase.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Case_recover,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 导出案件
     */
    RecoveredCase.prototype.exportCaseInfo = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.id; });
        var request = __assign(__assign({}, this.importModel), { caseIds: ids });
        this.CaseInfoService
            .recoveredCaseInfosExport(request)
            .subscribe(function (data) { return _this.$common.downloadFile(data.url); });
    };
    /**
     * 导出催记
     */
    RecoveredCase.prototype.exportFollowup = function () {
        var _this = this;
        var ids = this.selectionList.map(function (v) { return v.id; });
        var request = __assign(__assign({}, this.importModel), { caseIds: ids });
        this.CaseInfoService
            .recoveredCaseInfosExportFollow(request)
            .subscribe(function (data) { return _this.$common.downloadFile(data.url); });
    };
    /**
     * 更新回收方式
     */
    RecoveredCase.prototype.updateRecoveryType = function () {
        var _this = this;
        if (this.selectionList.length !== 0) {
            var recoveryTypeArr_1 = [];
            this.selectionList.forEach(function (e) {
                if (e.recoveryType && e.recoveryType === "PRINCIPAL_MANUAL_RECOVERY") {
                    recoveryTypeArr_1.push(e.recoveryType);
                }
            });
            if (recoveryTypeArr_1.length !== 0) {
                return this.$message("\u6240\u9009\u6848\u4EF6\u4E0D\u80FD\u5305\u542B\u59D4\u6258\u65B9\u56DE\u6536\u6848\u4EF6\uFF01");
            }
            var ids = this.selectionList.map(function (v) { return v.id; });
            var request_1 = {
                caseIds: ids
            };
            this.$confirm('确定更新所选案件为委托方回收吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(function () {
                _this.CaseInfoService
                    .updateRecoveryType(request_1).subscribe(function (data) {
                    _this.$message.success('操作成功!');
                    _this.refreshData();
                }, function (err) {
                    _this.$message.success('操作失败!');
                });
            });
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u66F4\u65B0\u56DE\u6536\u65B9\u5F0F\u7684\u6848\u4EF6");
        }
    };
    __decorate([
        State
    ], RecoveredCase.prototype, "principalList", void 0);
    __decorate([
        Dependencies(PageService)
    ], RecoveredCase.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], RecoveredCase.prototype, "CaseInfoService", void 0);
    RecoveredCase = __decorate([
        Auth(2313),
        Layout("workspace"),
        Component({
            components: {
                ManualDistrubute: ManualDistrubute,
                GetLabelName: GetLabelName,
                NumberRange: NumberRange
            }
        })
    ], RecoveredCase);
    return RecoveredCase;
}(Vue));
export default RecoveredCase;
